import React from "react"
import PropTypes from "prop-types"

import lottie from 'lottie-web';

class ProModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit"
    }
    this.headerText = this.headerText.bind(this)
    this.loadLottie = this.loadLottie.bind(this)

  }

  headerText() {
    switch (this.props.type) {
      case 'filter':
        return 'You discovered a pro filter!'
        break;
      case 'id':
        return 'Upgrade to verify your profile'
        break;
      default:
        return 'You discovered a pro feature!'

    }
  }
  sectionText() {
    switch (this.props.type) {
      case 'filter':
        return 'To unlock and use this filter, upgrade to Pro today!'
        break;
      case 'id':
        return 'To see only verified members, you must verify your profile first. Upgrade to confirm it is really you!'
        break;
      default:
        return 'To unlock and use this feature, upgrade to Pro today!'
    }
  }

  onClick() {
    switch (this.props.type) {
      case 'id':
        window.location.assign("/verify_identity_steps")
        break;
      default:
        window.location.assign("/pricing")
    }
  }

  loadLottie() {

  }

  componentDidMount() {
    lottie.loadAnimation({
      container: document.getElementById('loadingElement'),
      name: 'loadingElement',
      renderer: 'svg',
      loop: false,
      speed: .001,
      autoplay: true,
      path: this.props.confettiLottie
    })
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
  }

  render() {
    return(
      <div
        onClick={() => this.props.onClose()}
        style={{top: 0, left: 0, position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', zIndex: 11, backgroundColor: 'rgba(255,255,255,.5)'}}>
        <div className="standardModal" style={{padding: 0, textAlign: 'center'}}>
          <div style={{backgroundColor: "#F48FB1", padding: 15, borderTopLeftRadius: 8, borderTopRightRadius: 8}}>
            <h3 className="white">{this.headerText()}</h3>
          </div>
          <div style={{padding: 15, justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div className="proCrownSection"></div>
            <div id="loadingElement" style={{height: 200, width: 200, marginTop: -200}}>
            </div>
            <h4 className="darkBlue" style={{marginBottom: 30, marginTop: 30}}>{this.sectionText()}</h4>
            <button className="pro_button_primary" onClick={() => this.onClick()}>Upgrade Now</button>
          </div>

        </div >
      </div>
    )
  }
}

export default ProModal;
